import { render, staticRenderFns, recyclableRender, components } from "./collection.vue?vue&type=template&id=cb027c66&scoped=true&"
var renderjs
import script from "./collection.vue?vue&type=script&lang=js&"
export * from "./collection.vue?vue&type=script&lang=js&"
import style0 from "./collection.vue?vue&type=style&index=0&id=cb027c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb027c66",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/square/collection.vue"
export default component.exports